export default __webpack_public_path__ + "static/media/tutor.82bc6ac4.png";